"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var NameById_1 = require("./NameById");
var collectionsRef_1 = require("common/db/collectionsRef");
// --------------------------------
// Helpers and Components
// --------------------------------
var BreadcrumbItem = function (_a) {
    var loading = _a.loading, url = _a.url, label = _a.label;
    return ((0, jsx_runtime_1.jsx)(core_1.Link, __assign({ component: react_router_dom_1.NavLink, to: url, underline: "hover", color: "inherit" }, { children: loading ? (0, jsx_runtime_1.jsx)(core_1.CircularProgress, { size: 14 }) : label })));
};
var entityBreadcrumbFactory = function (tableName, paramKey, labelKey) {
    return function (url, match) {
        var _a = (0, NameById_1.useNameById)(collectionsRef_1.TABLES[tableName], match[paramKey]), data = _a.data, loading = _a.loading;
        return ((0, jsx_runtime_1.jsx)(BreadcrumbItem, { loading: loading, url: url, label: (data === null || data === void 0 ? void 0 : data[labelKey]) || "..." }));
    };
};
var routes = [
    {
        path: "/products/:productId",
        render: entityBreadcrumbFactory("products", "productId", "name"),
    },
    {
        path: "/suppliers/:supplierId",
        render: entityBreadcrumbFactory("suppliers", "supplierId", "companyName"),
    },
    {
        path: "/projects/:projectId",
        render: entityBreadcrumbFactory("projects", "projectId", "code"),
    },
    {
        path: "/warehouses/:warehouseId",
        render: entityBreadcrumbFactory("warehouses", "warehouseId", "name"),
    },
    {
        path: "/users/:userId",
        render: entityBreadcrumbFactory("users", "userId", "name"),
    },
    {
        path: "/budget-templates/:templateId",
        render: entityBreadcrumbFactory("budgetTemplates", "templateId", "title"),
    },
    {
        path: "/internal-requests/:irId",
        render: entityBreadcrumbFactory("IRs", "irId", "ref"),
    },
    {
        path: "/request-for-quotations/:RFQId",
        render: entityBreadcrumbFactory("RFQs", "RFQId", "RFQNo"),
    },
    {
        path: "/comparative-bid-analysis/:CBAId",
        render: entityBreadcrumbFactory("CBAs", "CBAId", "ref"),
    },
    {
        path: "/purchase-orders/:POId",
        render: entityBreadcrumbFactory("POs", "POId", "PONumber"),
    },
    {
        path: "/delivery-notes/:DNId",
        render: entityBreadcrumbFactory("DNs", "DNId", "DNNumber"),
    },
    {
        path: "/payment-requests/:PRId",
        render: entityBreadcrumbFactory("PRs", "PRId", "PRNumber"),
    },
    {
        path: "/service-complete-notes/:SCNId",
        render: entityBreadcrumbFactory("SCNs", "SCNId", "SCNNumber"),
    },
    {
        path: "/service-contract/:SCId",
        render: entityBreadcrumbFactory("SCs", "SCId", "SCNumber"),
    },
];
var RouteBreadcrumb = function (_a) {
    var route = _a.route, to = _a.to, matchParams = _a.matchParams;
    return (0, jsx_runtime_1.jsx)("span", { children: route.render(to, matchParams) });
};
var Breadcrumbs = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var pathnames = location.pathname.split("/").filter(function (x) { return x; });
    var breadcrumbItems = [];
    pathnames.forEach(function (_, index) {
        var to = "/" + pathnames.slice(0, index + 1).join("/");
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var route = routes_1[_i];
            var match = (0, react_router_dom_1.matchPath)({ path: route.path, end: true }, to);
            if (match) {
                breadcrumbItems.push((0, jsx_runtime_1.jsx)(RouteBreadcrumb, { route: route, to: to, matchParams: match.params }, to));
                return;
            }
        }
        // fallback to text breadcrumb
        breadcrumbItems.push((0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ color: "textPrimary" }, { children: decodeURIComponent(pathnames[index]) }), to));
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: "flex", alignItems: "center", gap: "8px" } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: t("common.youAreIn") }), (0, jsx_runtime_1.jsx)(core_1.Breadcrumbs, __assign({ separator: "\u203A", "aria-label": "breadcrumb" }, { children: breadcrumbItems }))] })));
};
exports.Breadcrumbs = Breadcrumbs;
